import React from "react";
import CloudBackground from "../../shared/components/CloudBackground";
import SitchLogo from "../../shared/components/SitchLogo";

interface EventPageLayoutProps {
  children: React.ReactNode;
  className?: string;
}

const EventPageLayout: React.FC<EventPageLayoutProps> = ({
  children,
  className = "",
}) => (
  <CloudBackground>
    <div
      className={`min-h-screen flex flex-col items-center px-6 pt-8 sm:pt-12 pb-16 ${className}`}
    >
      <div className="w-full max-w-md normal space-y-8">
        <SitchLogo />
        {children}
      </div>
    </div>
  </CloudBackground>
);

EventPageLayout.defaultProps = {
  className: "",
};

export default EventPageLayout;
